module.exports = __webpack_public_path__ + "img/soccerboard122.79636bf7.jpg";